import { general } from '@/services/api/ExpertoRetail'
import { getRootUsers } from '@/app/shared/services/rootUsersService'
import * as Sentry from '@sentry/vue'

export default {
  async fetchDesktopParameterConfig ({ commit }) {
    try {
      const response = await general.getDesktopParameterConfig()
      
      // Fetch root users for permission  system
      try {
        const rootUsers = await getRootUsers()
        response.rootUsers = rootUsers
      } catch (rootUsersError) {
        console.warn('Could not fetch root users for permission system:', rootUsersError)
        response.rootUsers = []
      }
      
      commit('setDesktopParameterConfig', response)

      // Configurar usuario en Sentry para rastreo de errore
      if (response.userInfo) {
        Sentry.setUser({
          id: response.userInfo.id?.toString() || 'unknown',
          email: response.userInfo.email || 'unknown',
          username: response.userInfo.username || response.userInfo.email || 'unknown'
        })
      }
    } catch (e) {
    }
  },
}


// WEBPACK FOOTER //
// ./src/store/actions.js